<template>
  <div class="container">
    <div v-bind:class="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-bind:class="result">
      <div class="text-center">
        <h4>Horarios de agentes ({{ this.items.nomagenteSistema }})</h4>
      </div>
      <div style="display: flex; justify-content: center; margin-top: 20px">
        <v-btn style="position: absolute; left: 20px" color="teleperformance-purpura2" @click="Volver()"> Volver </v-btn>
        <div style="width: 60%">
          <v-row class="fill-height">
            <v-col>
              <v-sheet height="64">
                <v-toolbar flat>
                  <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday"> Hoy </v-btn>
                  <v-btn fab text small color="grey darken-2" @click="prev">
                    <v-icon small> mdi-chevron-left </v-icon>
                  </v-btn>
                  <v-btn fab text small color="grey darken-2" @click="next">
                    <v-icon small> mdi-chevron-right </v-icon>
                  </v-btn>
                  <v-toolbar-title v-if="$refs.calendar">
                    {{ $refs.calendar.title }}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-menu bottom right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                        <span>{{ typeToLabel[type] }}</span>
                        <v-icon right> mdi-menu-down </v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="type = 'day'">
                        <v-list-item-title>Día</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = 'week'">
                        <v-list-item-title>Semana</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = 'month'">
                        <v-list-item-title>Mes</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="type = '4day'">
                        <v-list-item-title>4 Días</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-toolbar>
              </v-sheet>
              <v-sheet height="550">
                <v-calendar
                  ref="calendar"
                  v-model="focus"
                  color="primary"
                  :events="events"
                  :event-color="getEventColor"
                  :type="type"
                  @click:more="viewDay"
                  @click:date="viewDay"
                  @change="updateRange"
                ></v-calendar>
              </v-sheet>
            </v-col>
          </v-row>
          <!-- <v-date-picker locale="es" color="teleperformance-purpura2" v-model="date" full-width></v-date-picker> -->
        </div>
      </div>
      <v-card rounded class="mx-auto mt-8" max-width="900" outlined style="border-radius: 36px !important">
        <v-card-title style="justify-content: center"> Detalle por dia {{ focus }} </v-card-title>
        <div v-if="focusEvents.length > 0">
          <v-card-text v-for="(item, idx) in focusEvents" :key="idx">
            <div class="my-2 text-subtitle-1">Tipo de evento: {{ item.idactividad }}</div>
            <div>Fecha inicio: {{ item.fechaInicioHorario + " " + item.horaInicioActividad }}</div>
            <div>Fecha fin: {{ item.fechaInicioHorario + " " + item.horaFinActividad }}</div>
          </v-card-text>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import GeneralMixin from "@/components/mixins/General";
import axios from "axios";

export default {
  mixins: [GeneralMixin],
  data() {
    return {
      url: process.env.VUE_APP_URL,
      name: "Agregar",
      items: [],
      loading: "",
      result: "d-none",
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),

      //
      focus: "",
      focusEvents: [],
      type: "month",
      typeToLabel: {
        month: "Mes",
        week: "Semana",
        day: "Día",
        "4day": "4 Días",
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      colors: ["blue", "indigo", "deep-purple", "cyan", "green", "orange", "grey darken-1"],
      names: ["Meeting", "Holiday", "PTO", "Travel", "Event", "Birthday", "Conference", "Party"],
    };
  },
  methods: {
    Cargando() {
      this.loading = "";
      this.result = "d-none";
    },
    Listo() {
      this.loading = "d-none";
      this.result = "";
    },
    Volver() {
      this.$router.push({ name: "Supervisores" });
    },
    async Consultar() {
      try {
        this.Cargando();
        // A futuro cambiara la estructura del proyecto y esto quedara en el router estos dos headers
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("apiKey_tp");
        axios.defaults.headers.common["accesstoken"] = localStorage.getItem("tokenmsal");

        const url = this.url + "v2/api/admin/supervisores/calendario/por/agente";
        let data = {
          agente: this.$route.params.id,
        };
        const { data: item } = await axios.post(url, { data });
        this.items = item;

        this.updateRange();
        // this.items = items.map((obj) => {
        //   return {
        //     ...obj,
        //     fecha_evento: moment(obj.fecha_evento).utc().format("YYYY-MM-DD"),
        //   };
        // });

        // if (this.items != null) {
        //   this.ausencias = this.items;
        // }
        // if (this.ausencias.length === 0) {
        //   swal("No hay ausencias", "Por el momento no hay solicitudes", "info");
        // }
        this.loading = "d-none";
        this.result = "";
      } catch (error) {
        if (error.body?.code === "MSAL_TOKEN_IS_NOT_VALID") {
          this.$msal.signOut();
        }
        if (error.status !== 401) {
          swal("Problemas para conectarse", "Favor de revisar su conexión a internet", "error");
        }
        this.Listo();
      }
    },

    //
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() => requestAnimationFrame(() => (this.selectedOpen = true)));
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange() {
      const events = [];
      this.focusEvents = [];
      for (let i = 0; i < this.items.calendario.length; i++) {
        const fechaCompletaTextoInicio = `${this.items.calendario[i].fechaInicioHorario}T${this.items.calendario[i].horaInicioActividad}:00`;
        const timestampInicio = Date.parse(fechaCompletaTextoInicio);

        const fechaInicio = new Date(timestampInicio);

        const fechaCompletaTextoFin = `${this.items.calendario[i].fechaInicioHorario}T${this.items.calendario[i].horaFinActividad}:00`;
        const timestampFin = Date.parse(fechaCompletaTextoFin);

        const fechaFin = new Date(timestampFin);
        if (this.items.calendario[i].fechaActividad === this.focus) {
          this.focusEvents.push(this.items.calendario[i]);
        }

        events.push({
          name: this.items.calendario[i].idactividad,
          start: fechaInicio,
          end: fechaFin,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: true,
        });
      }

      this.focusEvents.sort((a, b) => {
        const horaInicioA = a.horaInicioActividad;
        const horaInicioB = b.horaInicioActividad;

        if (horaInicioA < horaInicioB) {
          return -1;
        } else if (horaInicioA > horaInicioB) {
          return 1;
        } else {
          return 0;
        }
      });

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
  },
  computed: {},
  beforeMount() {
    this.Consultar();
  },
  mounted() {
    this.$refs.calendar.checkChange();
  },
};
</script>

<style></style>
